module.exports = __webpack_public_path__ + "static/media/IMG_0559.8f1c74be.jpg";